var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:{
        'deferred-img': true,
        'deferred-img--loading': _vm.isLoading,
    },attrs:{"alt":_vm.alt,"title":_vm.title,"src":_vm.fakeImg}})}
var staticRenderFns = []

export { render, staticRenderFns }